export default __webpack_public_path__ + "static/media/TheRiseofIndianTypewriter.bd8351f5.pdf";